<template>
    <div class="col-12">
        <v-card>
            <v-app-bar
                dark
                height="auto"
                class="period-toolbar bg-primary">
                <div class="d-flex justify-content-between w-100">
                    <div class="mt-auto mb-auto cmaj-title align-items-center d-flex justify-content-between w-100">
                        <div class="d-md-flex gap-30">
                            <div>
                                Du
                                <h4 class="text-white">{{ formatDate(period.valid_from, false) }}</h4>
                            </div>
                            <div>
                                au
                                <h4 class="text-white">{{ formatDate(period.valid_through, false) }}</h4>
                            </div>
                        </div>

                        <div class="d-flex gap-30">
                            <div class="mb-1">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            v-on="on"
                                            icon
                                            @click="prepareEdit()"
                                            class="edit-btn"
                                        >
                                            <v-icon dense>edit</v-icon>
                                        </v-btn>
                                    </template>
                                    <div>Modifier</div>
                                </v-tooltip>
                            </div>

                            <div>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            v-on="on"
                                            icon
                                            @click="confirmDelete()"
                                            class="close-btn"
                                        >
                                            <v-icon dense>close</v-icon>
                                        </v-btn>
                                    </template>
                                    <div>Supprimer</div>
                                </v-tooltip>
                            </div>
                        </div>
                    </div>
                </div>
            </v-app-bar>

            <v-card-text style="font-size: 16px">
                <div v-if="period.h24">Ouvert 24h/24 et 7j/7</div>
                <div v-else>
                    <div
                        v-for="day in period.opening_days"
                        class="row border-bottom hour-item"
                    >
                        <div class="col-3 py-2 align-items-center d-flex">
                            {{ daysOfWeek[day.day_of_week] }}
                        </div>
                        <div class="col py-2">
                            <div v-if="day.closed || day.opening_hours.length === 0">Fermé</div>
                            <div
                                v-else-if="day.opening_hours[0].open !== null"
                                class="d-flex"
                            >
                                <div class="d-flex align-items-center">
                                    <v-chip>
                                        {{ day.opening_hours[0].open }}
                                    </v-chip>
                                    <div class="mr-1 ml-1">/</div>
                                    <v-chip>
                                        {{ day.opening_hours[0].close }}
                                    </v-chip>
                                </div>

                                <div class="d-flex align-items-center"
                                     v-if="day.opening_hours.length > 1 &&
                                       day.opening_hours[1].open !== null &&
                                       day.opening_hours[1].close !== null">
                                    <div class="mr-2 ml-2">–</div>
                                    <v-chip>
                                        {{ day.opening_hours[1].open }}
                                    </v-chip>
                                    <div class="mr-1 ml-1">/</div>
                                    <v-chip>
                                        {{ day.opening_hours[1].close }}
                                    </v-chip>
                                </div>
                            </div>
                            <div v-else-if="!day.closed" class="text-success">Ouvert</div>
                            <div v-else>Non renseigné</div>
                        </div>
                    </div>
                </div>
                <div class="mt-5 justify-content-between d-flex"
                     v-if="period.description !== null && period.description !== ''">
                    <div><b>Complément horaire</b></div>

                    <div style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden; max-width: 50%">
                        {{ period.description }}
                    </div>
                </div>
            </v-card-text>

            <confirm ref="confirm"></confirm>
        </v-card>
    </div>
</template>

<script>
import Confirm from "../../../../tools/Confirm.vue"
import {mapState, mapMutations} from "vuex"

export default {
    name: "OpeningPeriodTable",
    components: {Confirm},
    props: ['period', 'index'],
    data() {
        return {
            daysOfWeek: ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"]
        }
    },
    methods: {
        ...mapMutations('web_form', ['setAddOpeningPeriodDialog', 'setCurrentOpeningPeriod']),
        confirmDelete() {
            let period = this.provider.opening_periods[this.index]

            this.$refs.confirm.open(
                "Attention",
                "Vous allez supprimer les horaires saisies pour la période du " +
                this.formatDate(period.valid_from, false) +
                " au " +
                this.formatDate(period.valid_through, false) +
                ". " +
                "Êtes-vous sûr de vouloir supprimer cette période ?",
                { color: "red", confirmColor: "red", cancelColor: "#0b697e" }
            )
            .then((confirm) => {
                if (confirm) {
                    this.provider.opening_periods.splice(this.index, 1)
                }
            })
        },
        prepareEdit() {
            this.setCurrentOpeningPeriod(JSON.parse(JSON.stringify(this.period)))
            this.setAddOpeningPeriodDialog(true)
        },
    },
    computed: {
        ...mapState("web_form", ['provider']),
    }
}
</script>
